import { Box, Grow } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { useEffect, useState } from 'react';
import useWidth from '../../components/Hooks/useWidth';
import PopoverOrDialogInMobileWrapper from '../../components/PopoverOrDialogInMobileWrapper/PopoverOrDialogInMobileWrapper';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { useChatHandlerStyles } from './chatHandler.styles';
import ChatBubble from './components/ChatBubble/ChatBubble';
import ChatConfigViews from './components/ChatConfigViews/ChatConfigViews';
import ChatMessagesWithContext from './components/ChatMessages/ChatMessages';
import { useChatContext } from './contexts/chat/chat.context';
import { ChatContextProps } from './contexts/chat/chat.context.types';
import { useChatModalContext } from './contexts/chatModal/ChatModal.context';
import { CHAT_WIDTH } from './utils/chat.constants';

const ChatHandler = () => {
  const { isEnableChat } = useFeatureFlag();
  const { mobileWidth } = useWidth();

  const { classes } = useChatHandlerStyles();

  const { activeChat, minimizedChatIds } = useChatContext();
  const { close, isOpen, anchorEl } = useChatModalContext();

  const [currentActiveChat, setCurrentActiveChat] =
    useState<ChatContextProps['activeChat']>(undefined);

  useEffect(() => {
    setTimeout(() => {
      setCurrentActiveChat(activeChat);
    }, 250);

    return () => {
      setCurrentActiveChat(undefined);
    };
  }, [activeChat]);

  useEffect(() => {
    const removeBodyOverflow = isOpen || !!currentActiveChat;
    if (!mobileWidth || !removeBodyOverflow) {
      return;
    }

    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, currentActiveChat, mobileWidth]);

  const leftPositionFromChat = minimizedChatIds.length ? '88px' : '16px';

  return !isEnableChat ? null : (
    <>
      <PopoverOrDialogInMobileWrapper
        testId="chat-config-views"
        isOpen={isOpen}
        onClose={close}
        anchorEl={anchorEl}
        transitionComponent="slide"
        transitionProps={{ direction: 'right' } as TransitionProps}
        popoverOrigin={{
          vertical: 64,
          horizontal: -CHAT_WIDTH,
        }}
      >
        <ChatConfigViews />
      </PopoverOrDialogInMobileWrapper>

      <Grow in={!!currentActiveChat} timeout={250}>
        <Box
          className={classes.chatMessageWrapper}
          sx={{
            left: leftPositionFromChat,
          }}
        >
          {currentActiveChat && <ChatMessagesWithContext />}
        </Box>
      </Grow>

      <Box
        test-id="chat-bubbles-wrapper"
        className={classes.bubblesWrapper}
        sx={{
          left: '20px',
          bottom: '20px',
          display: 'flex',
          gap: '12px',
          position: 'fixed',
          zIndex: (theme) => theme.zIndex.modal - 1,
          flexDirection: 'column-reverse',
        }}
      >
        {minimizedChatIds.map((chatId) => (
          <ChatBubble key={chatId} chatId={chatId} />
        ))}
      </Box>
    </>
  );
};

export default ChatHandler;
